import React from 'react';
import { useSearchParams } from 'react-router-dom';
import OnboardingChat from '../../components/OnboardingChat/OnboardingChat';

export default function Onboarding() {
    const [searchParams] = useSearchParams();
    const orgFromQuery = searchParams.get('org')?.trim() ?? '';

    return (
        <div style={{
            minHeight: '100vh',
            backgroundColor: '#F6F4FF',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        }}>
            <div style={{
                padding: '24px 24px 0',
                width: '100%',
                maxWidth: '600px',
            }}>
                <img
                    src="/cb_logo.png"
                    alt="ClientBloom"
                    style={{ height: '32px' }}
                />
            </div>
            <OnboardingChat orgFromQuery={orgFromQuery} />
        </div>
    );
}
